module.exports = __webpack_public_path__ + "img/big_hearts.bb49b59a.svg";